import { Button } from "components";
import { useLayoutData } from "contexts/LayoutContext";

import { SubmittedContract } from "./SubmittedContract";
import { UnSubmittedContract } from "./UnSubmittedContract";

export const ContractDetailsConfirmation = ({
  onConfirmContract,
  isConfirmContract,
  confirmContractContentAt,
}: {
  onConfirmContract: () => void;
  isConfirmContract: boolean;
  confirmContractContentAt: string;
}) => {
  const { isLesseeSubmitContractForm } = useLayoutData<{
    isLessorSendContractForm?: boolean;
    isLesseeSubmitContractForm?: boolean;
  }>();

  return (
    <div className="flex flex-col bg-white px-10 py-6">
      <h1 className="flex justify-between text-2xl leading-[1.25]">契約内容の確認</h1>
      <p className="text-m my-4">契約内容を確認して「確認完了」をクリックしてください。</p>

      <div className="border border-border px-8 py-6">
        {isLesseeSubmitContractForm ? <SubmittedContract /> : <UnSubmittedContract />}

        <div className="flex items-center justify-end gap-2.5 border-t border-border pt-6">
          {confirmContractContentAt && <span className="text-s text-gray">確認完了 {confirmContractContentAt}</span>}
          <Button
            isLoading={false}
            isDisabled={isConfirmContract}
            style="outline"
            width="w-[240px]"
            type="submit"
            text="確認完了（契約書の作成へ）"
            onClick={onConfirmContract}
          />
        </div>
      </div>
    </div>
  );
};
